<template>
  <div class="home overflow-hidden">
    <Header class="pb-5" :sidebar="sidebar"/>
    <!-- <ShopLanding /> -->
    <courseIndividual v-if="!errorPage" />
    <errorPage v-if="errorPage" />
    <!-- <Test /> -->
    <Footer class="mt-5" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import ShopLanding from "@/components/shop/landing.vue";
import courseIndividual from "@/components/shop/course.vue";
import errorPage from "@/components/errorPage.vue";
export default {
  name: "Course",
    components: {
    Header,
    ShopLanding,
    courseIndividual,
    errorPage,
    Footer
  },
  data(){
    return {
      sidebar: false
    }
  },
  computed: {
    errorPage: {
      get: function(){
        return this.$store.getters.getcourseError
      }
    } 
  },
  methods: {
    ...mapActions(["fetchCourseData"]),  
    openSidebar(){
        this.sidebar = !this.sidebar
    }
  },
  created(){
    document.title = "Avishkaar shop";
    this.fetchCourseData(this.$route.params.code)
  }
};
</script>

